import React from 'react';


export default class Falha extends React.Component{
  constructor(props) {
    super(props);

    this.state = {

    };

  }

  render(){
    const strings = this.state.strings;
    const video = '292714835';
    return(
      <div>
        <div>Neste vídeo você vai aprender como aplicar a falha concêntrica nos seus treinos (no Foco90 usamos a falha em todos os exercícios), e como mensurar as repetições em relação ao peso da carga. Exemplos no final do vídeo.</div>
          <iframe
            className='vimeo-video'
            src={`https://player.vimeo.com/video/${video}?autoplay=1&loop=1&autopause=0`}
            height="300"
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen="true">
          </iframe>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/tecnicas/Falha.js